import TenderEvalTable from './TenderEvalTable';

const ProductHydro = ({ refreshTrigger, exportName }) => (
  <TenderEvalTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
    exportName={exportName}
  />
);

export default ProductHydro;
